import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const ErrorsLayout = lazy(() => import('@/pages/errors/layout'));
const ErrorsListPage = lazy(() => import('@/pages/errors'));
const ErrorViewPage = lazy(() => import('@/pages/errors/detail/view'));

/**
 * UG-4507 — error-log routes (legacy `app/(dashboard)/errors/*`): the grid
 * plus the full-page detail view (legacy `[errorId]/view`). Both paths are
 * `errors.view`-gated in `@/config/auth/routeAccess`; `ErrorsLayout` mounts
 * the section breadcrumb.
 */
export const errorRoutes: RouteConfig = {
  path: '/errors',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: ErrorsLayout,
      children: [
        { path: '', element: ErrorsListPage },
        { path: '/:errorId/view', element: ErrorViewPage },
      ],
    },
  ],
};
